export default __webpack_public_path__ + "static/media/AdjustCropClip.55e78b2e.gif";